import {NumberInputProps} from '../components/number-input';

export const getNumberInput =
  <T>(data: Omit<NumberInputProps<T>, 'type'>) =>
  (): NumberInputProps<T> => ({
    ...data,
    type: 'number-input',
  });
